module.exports = __webpack_public_path__ + "40b21d9cab79b97dbdbc7a606d15c06d.svg";